import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 px-4 sm:px-6 pt-3 sm:pt-4`}>
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between rounded-2xl transition-all duration-300 ${
          scrolled 
            ? 'bg-white/80 backdrop-blur-xl border border-slate-200/50 shadow-xl' 
            : 'bg-white/60 backdrop-blur-md border border-slate-200/30 shadow-lg'
        }`}>
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
            <img 
              src="/logo.png" 
              alt="OwlWorkLabs Logo" 
              className="w-12 h-12 sm:w-14 sm:h-14 object-contain logo-float cursor-pointer"
            />
            <div className="flex flex-col">
              <span className="text-xl sm:text-2xl font-bold text-slate-900">OwlWorkLabs</span>
              <p className="text-xs text-slate-600 hidden sm:block">Building Intelligent Systems</p>
            </div>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-3">
            <a href="/#ventures" className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-all duration-300 px-4 py-2 rounded-full bg-slate-100/50 backdrop-blur-sm hover:bg-white/80 hover:shadow-md border border-slate-200/50">
              Ventures
            </a>
            <a href="/#consulting" className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-all duration-300 px-4 py-2 rounded-full bg-slate-100/50 backdrop-blur-sm hover:bg-white/80 hover:shadow-md border border-slate-200/50">
              Consulting
            </a>
            <Link to="/about" className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-all duration-300 px-4 py-2 rounded-full bg-slate-100/50 backdrop-blur-sm hover:bg-white/80 hover:shadow-md border border-slate-200/50">
              About
            </Link>
            <a href="/#contact" className="text-sm font-medium text-white bg-slate-900 px-5 py-2 rounded-full hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105">
              Contact
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-5 h-5 text-slate-900" /> : <Menu className="w-5 h-5 text-slate-900" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 z-40 md:hidden transition-all duration-300 ${
        mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}>
        {/* Backdrop */}
        <div 
          className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
        
        {/* Menu Content */}
        <div className={`absolute top-20 left-4 right-4 bg-white/95 backdrop-blur-xl rounded-2xl border border-slate-200 shadow-2xl p-6 transition-all duration-300 ${
          mobileMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'
        }`}>
          <nav className="flex flex-col gap-3">
            <a
              href="/#ventures"
              onClick={() => setMobileMenuOpen(false)}
              className="text-left text-base font-medium text-slate-700 hover:text-slate-900 transition-all duration-300 px-4 py-3 rounded-xl bg-slate-50 hover:bg-slate-100"
            >
              Ventures
            </a>
            <a
              href="/#consulting"
              onClick={() => setMobileMenuOpen(false)}
              className="text-left text-base font-medium text-slate-700 hover:text-slate-900 transition-all duration-300 px-4 py-3 rounded-xl bg-slate-50 hover:bg-slate-100"
            >
              Consulting
            </a>
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className="text-left text-base font-medium text-slate-700 hover:text-slate-900 transition-all duration-300 px-4 py-3 rounded-xl bg-slate-50 hover:bg-slate-100"
            >
              About
            </Link>
            <a
              href="/#contact"
              onClick={() => setMobileMenuOpen(false)}
              className="text-left text-base font-medium text-white bg-slate-900 px-4 py-3 rounded-xl hover:bg-slate-800 transition-all duration-300 shadow-lg"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;